/* eslint-disable */
export default {
  infoMessageMins: 'Auto-save log in {delayTime} minutes...',
  infoMessageMin: 'Auto-save log in {delayTime} minute...',
  infoMessageSecs: 'Auto-save log in {delayTime} seconds...',
  infoMessageSec: 'Auto-save log in {delayTime} second...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
